module.exports = __webpack_public_path__ + "blzee.6c2cfe80fc3daeb2a436.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/blzee/blzee.ttf
// module id = ../../../../../src/assets/fonts/blzee/blzee.ttf
// module chunks = styles